import { render } from "./ConfigRawJson.vue?vue&type=template&id=563efe5f"
import script from "./ConfigRawJson.vue?vue&type=script&lang=js"
export * from "./ConfigRawJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__